import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import ScoreBoard from 'newDesign/modules/common/components/oddsPanel/scoreBoard/ScoreBoard';
import { sport } from 'constants/enum';
import {
  getScoreBreak,
  getClockBreak,
  getMatchSportId,
  getReadyMatchId,
} from 'reducers';

const mapStateToProps = state => ({
  scoreBreak: getScoreBreak(state),
  clockBreak: getClockBreak(state),
  sportId: getMatchSportId(state, getReadyMatchId(state)),
  matchId: getReadyMatchId(state),
});

class ScoreboardManager extends React.Component {
  shouldComponentUpdate(nextProps) {
    if (this.props.scoreBreak !== nextProps.scoreBreak) {
      return false;
    }
    if (this.props.clockBreak !== nextProps.clockBreak) {
      return false;
    }

    return true;
  }

  render() {
    switch (this.props.sportId) {
      case undefined:
      case null:
      case 0:
        return <div />;
      case sport.basketball:
      case sport.ebasketball:
      case sport.basketball3x3:
      case sport.esoccer:
      case sport.soccer:
      case sport.tennis:
      case sport.table_tennis:
      case sport.ice_hockey:
      case sport.handball:
      case sport.volleyball:
      case sport.beach_volley:
      case sport.futsal:
        return <ScoreBoard
          key={this.props.matchId}
        />;
      default:
        return null;
    }
  }
}

ScoreboardManager.propTypes = {
  matchId: PropTypes.number.isRequired,
  scoreBreak: PropTypes.bool,
  clockBreak: PropTypes.bool,
  sportId: PropTypes.number,
};

ScoreboardManager.defaultProps = {
  scoreBreak: 0,
  clockBreak: 0,
  sportId: null,
};

export default connect(
  mapStateToProps,
)(ScoreboardManager);
